









































import useVuelidate from "@vuelidate/core";
import InputGroup from "@/components/InputGroup.vue";
import { maxLength, required } from "@/utilities/validators";
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  components: { InputGroup },
  props: {
    visible: Boolean,
    title: String,
    upstreamIdpUserIdPlaceholder: String,
    upstreamIdpIdPlaceholder: String,
    isLoading: Boolean,
  },
  emits: ["add"],
  setup(_, { emit }) {
    const upstreamIdpUserId = ref("");
    const upstreamIdpId = ref("");

    const v$ = useVuelidate(
      useValidations(),
      {
        upstreamIdpUserId,
        upstreamIdpId,
      },
      {
        $autoDirty: true,
        $lazy: true,
      }
    );

    const onAdd = async () => {
      if (!(await v$.value.$validate())) return;

      emit("add", {
        upstreamIdpUserId: upstreamIdpUserId.value,
        upstreamIdpId: upstreamIdpId.value,
      });
    };

    return { v$, upstreamIdpUserId, upstreamIdpId, onAdd };
  },
});

function useValidations() {
  return {
    upstreamIdpUserId: { required, maxLength: maxLength(255) },
    upstreamIdpId: { required, maxLength: maxLength(255) },
  };
}
